import servicosRotas from './servicos/ServicosRotas'

export default {
    path: 'uabs',
    name: 'Gescon_Uabs',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [servicosRotas]
}
